export const CONTENT_TYPES = {
    MOVIE: 'MOVIE',
    SERIE: 'SERIE',
    EPISODE: 'EPISODE',
    BROADCAST: 'BROADCAST',
    SPORT: 'SPORT',
  };